import { type OrganicStatsResponseTimeEntry } from "../../gql-generated/types";
import { type GetOrganicStatsQuery } from "../api/queries";

export const getStatsResponseTimeEntryList = (
    data: GetOrganicStatsQuery | undefined,
): readonly OrganicStatsResponseTimeEntry[] => {
    return data?.getMyLensesOrganicStats.responseEntryList[0]?.statsResponseTimeEntryList ?? [];
};
